'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumMenuDown = ({ testId, className })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.8184 6.92683L8.47893 9.83995C8.23561 10.0535 7.76453 10.053 7.52189 9.84052L4.18104 6.92683C4.00058 6.76889 3.94922 6.5362 4.0533 6.33161C4.15739 6.12983 4.39597 6 4.65956 6H11.3399C11.6042 6 11.8421 6.12983 11.9475 6.33386C12.0502 6.5362 11.9996 6.76889 11.8184 6.92683Z",
            fill: "currentColor"
        })
    });
};

module.exports = MediumMenuDown;
